<div *ngIf="notifications?.length === 0">You do not have any notifications</div>

<div class="daily-plan-wrapper mt-0">
  <ul *ngIf="notifications.length > 0">
    <li *ngFor="let notification of notifications">
      <div class="grid">
        <div class="col-auto flex justify-content-center align-items-center">
          <div class="rounded-circle bg-light ml-3 py-1">
            <i class="pi pi-exclamation-circle"></i>
          </div>
        </div>

        <div class="col">
          <h6 class="event-topic mt-3">
            {{ notification?.message }}
          </h6>
          <small>
            <span class="event-time">
              {{ notification.dateCreated | date: 'medium' }}
            </span>
          </small>
        </div>
      </div>
    </li>
  </ul>
</div>
